var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-button',{staticStyle:{"float":"left"},attrs:{"type":"primary"},on:{"click":function($event){return _vm.openDialog(_vm.current.dialogName)}}},[_vm._v(_vm._s(_vm.$t(_vm.current.import_name)))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }